export class FieldValueModel {
    public FieldId: number;
    public FieldName: string;
    public Value: any;
    public Type: string;
}



// WEBPACK FOOTER //
// ./src/app/models/field-value-model.ts